import { every } from 'lodash';
/**
 * Memoize a function using a specific key for caching. Similar to defaultMemoize from reselect except that it can store
 * multiple previous values.
 * @param keyBuilder A function that takes the arguments to the memoized function and returns the key to use for caching
 * @param func The function to memoize
 * @param equalityCheck Optional function to check for equality. Defaults to reference equality
 * @returns A memoized version of the function
 */
export default function memoizeOn(keyBuilder, func, equalityCheck = (a, b) => a === b) {
    const cache = {};
    return (...args) => {
        const key = keyBuilder.apply(void 0, args);
        if (cache.hasOwnProperty(key)) {
            const { lastValue, lastArgs } = cache[key];
            if (every(args, (arg, i) => equalityCheck(arg, lastArgs[i]))) {
                return lastValue;
            }
        }
        const value = func.apply(void 0, args);
        cache[key] = {
            lastValue: value,
            lastArgs: args
        };
        return value;
    };
}
